import { grey, blueGrey } from '@material-ui/core/colors';
import { createMuiTheme, Theme as MUITheme } from '@material-ui/core';
import personalThanksBg from '../static/images/skoda2.png';
import personalAgreement from '../static/images/personal-agreement-bg.png';
import { BrandsEnum } from '../surveyCollector/SurveyCollector';

const mainColor = '#78faae';
const emerald = '#0e3a2f';

const { spacing } = createMuiTheme();

const myGreen = {
  A800: '#0E3A2F',
  A600: '#419468',
  A500: '#59BC87',
  A200: '#ABFFCC',
  A300: '#78FAAE',
};

const fontFamily =
  '"SKODA Next", "Helvetica Neue", Helvetica, Arial, sans-serif';

const theme = {
  layout : {
    headerStyle: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '10px',
      flexWrap: 'nowrap',
    },
    gridLogo: {
      margin: spacing(),
      marginTop: 0,
      marginLeft: 0,
      marginBottom: 0,
    },
    languageSelect: undefined,
  },
  palette: {
    primary: blueGrey,
    secondary: grey,
    starColor: mainColor,
    emerald: emerald,
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: fontFamily,
    useNextVariants: true,
  },
  screenElement: {
    sidePadding: spacing(3),
    sidePaddingXs: spacing(),
  },
  images: {
    introDefaultImagePath: '',
    progressImagePath: '',
    logo: '',
    favicon: '',
  },
  personalAgreement: {
    backgroundImagePath: personalAgreement,
    continueButtonColor: mainColor,
  },
  thanks: {
    backgroundImagePath: personalThanksBg,
  },
  title: 'Survey',
  brandCode: BrandsEnum.DEFAULT,
};

export type DefaultTheme = typeof theme & MUITheme;
export default theme;
